<template>
  <div class="h-full" v-if="this.mentalHealthStatus">
    <vx-card class="h-full" :title="$t('view_member.block.mental_health_status.title')">
      <vs-row vs-justify="center">
        <vs-col vs-w="2" vs-xs="7">
          <vs-row>
            <vs-col vs-w="2">
              <span class="green-dot"></span>
            </vs-col>
            <vs-col vs-w="10">
              <p class="ml-2">Complete</p>
            </vs-col>
          </vs-row>
        </vs-col>
        <vs-col vs-w="2" vs-xs="7">
          <vs-row>
            <vs-col vs-w="2">
              <span class="orange-dot"></span>
            </vs-col>
            <vs-col vs-w="10">
              <p class="ml-2">In progress</p>
            </vs-col>
          </vs-row>
        </vs-col>
        <vs-col vs-w="2" vs-xs="7">
          <vs-row>
            <vs-col vs-w="2">
              <span class="gray-dot"></span>
            </vs-col>
            <vs-col vs-w="10">
              <p class="ml-2">Not started</p>
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>
      <vs-row class="mt-8 p-3">
        <vs-col vs-w="4" vs-xs="12" class="p-3">
          <vs-row class="mb-2">
            <vs-col>
              <strong>Phase 1: Initial Assessments</strong>
            </vs-col>
          </vs-row>
          <vs-row class="py-2">
            <vs-col vs-w="1">
              <span :class="mentalHealthStatus.stressor ? 'green-dot' : 'gray-dot'"></span>
            </vs-col>
            <vs-col vs-w="11">
              <p class="ml-2">Identification of stressors</p>
            </vs-col>
          </vs-row>
          <vs-row class="py-2">
            <vs-col vs-w="1">
              <span :class="mentalHealthStatus.gad7 || mentalHealthStatus.phq9 ? 'green-dot' : 'gray-dot'"></span>
            </vs-col>
            <vs-col vs-w="11">
              <p class="ml-2">Evidence-based assessment of depression and anxiety</p>
            </vs-col>
          </vs-row>
          <vs-row class="py-1">
            <vs-col vs-w="1">
              <span :class="mentalHealthStatus.wsas ? 'green-dot' : 'gray-dot'"></span>
            </vs-col>
            <vs-col vs-w="11">
              <p class="ml-2">Standardized assessment of work and life functioning</p>
            </vs-col>
          </vs-row>
        </vs-col>
        <vs-col vs-w="4" vs-xs="12" class="p-3">
          <vs-row class="mb-2">
            <vs-col>
              <strong>Phase 2: CBT Strategies</strong>
            </vs-col>
          </vs-row>
          <vs-row class="py-2">
            <vs-col vs-w="1">
              <span :class="getClass(mentalHealthStatus.basicConcepts)"></span>
            </vs-col>
            <vs-col vs-w="11">
              <p class="ml-2">Basic mental health concepts</p>
            </vs-col>
          </vs-row>
          <vs-row class="py-1">
            <vs-col vs-w="1">
              <span :class="getClass(mentalHealthStatus.problemMoods)"></span>
            </vs-col>
            <vs-col vs-w="11">
              <p class="ml-2">Identify problems moods, reactions and triggers</p>
            </vs-col>
          </vs-row>
          <vs-row class="py-2">
            <vs-col vs-w="1">
              <span :class="getClass(mentalHealthStatus.emotionalRegulation)"></span>
            </vs-col>
            <vs-col vs-w="11">
              <p class="ml-2">Behavior strategies</p>
            </vs-col>
          </vs-row>
          <vs-row class="py-2">
            <vs-col vs-w="1">
              <span :class="getClass(mentalHealthStatus.goalSetting)"></span>
            </vs-col>
            <vs-col vs-w="11">
              <p class="ml-2">Goal setting strategies</p>
            </vs-col>
          </vs-row>
          <vs-row class="py-2">
            <vs-col vs-w="1">
              <span :class="getClass(mentalHealthStatus.cognitiveRestructuring)"></span>
            </vs-col>
            <vs-col vs-w="11">
              <p class="ml-2">Thought balancing strategy</p>
            </vs-col>
          </vs-row>
        </vs-col>
        <vs-col vs-w="4" vs-xs="12" class="p-3">
          <vs-row class="mb-2">
            <vs-col>
              <strong>{{ $t("view_member.block.report.texts.phase_three") }}</strong>
            </vs-col>
          </vs-row>
          <vs-row class="py-2">
            <vs-col vs-w="1">
              <span :class="getClass(mentalHealthStatus.proactiveBarriers)"></span>
            </vs-col>
            <vs-col vs-w="11">
              <p class="ml-2">Proactive identification of potential barriers to returning to work</p>
            </vs-col>
          </vs-row>
          <vs-row class="py-2">
            <vs-col vs-w="1">
              <span :class="getClass(mentalHealthStatus.proactiveStressors)"></span>
            </vs-col>
            <vs-col vs-w="11">
              <p class="ml-2">Proactive identification of work stressors</p>
            </vs-col>
          </vs-row>
          <vs-row class="py-2">
            <vs-col vs-w="1">
              <span :class="getClass(mentalHealthStatus.proactiveCBT)"></span>
            </vs-col>
            <vs-col vs-w="11">
              <p class="ml-2">Proactive planning of CBT strategies to manage work stressors</p>
            </vs-col>
          </vs-row>
          <vs-row class="py-2">
            <vs-col vs-w="1">
              <span :class="getClass(mentalHealthStatus.rtw)"></span>
            </vs-col>
            <vs-col vs-w="11">
              <p class="ml-2">RTW scripts for key stakeholders (i.e. Managers & Colleagues)</p>
            </vs-col>
          </vs-row>
          <vs-row class="py-2">
            <vs-col vs-w="1">
              <span :class="getClass(mentalHealthStatus.relapsePrevention)"></span>
            </vs-col>
            <vs-col vs-w="11">
              <p class="ml-2">Relapse prevention plan in place</p>
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>
    </vx-card>
  </div>
</template>

<script>
import {ResourceImpl} from 'hal-client';

export default {
  name: 'view-member',
  props: {
    memberResource: ResourceImpl
  },
  data () {
    return {
      mentalHealthStatus : null
    };
  },
  mounted () {
    this.memberResource.$request().$get('mental-health').then(res => {
      this.mentalHealthStatus = res.state();
    });
  },
  methods : {
    getClass (value) {
      if (value === 'NOT_STARTED') {
        return 'gray-dot';
      } else if (value === 'STARTED') {
        return 'orange-dot';
      } else {
        return 'green-dot';
      }
    }
  }
};
</script>

<style>

</style>